import { useState } from "react";
import {
  Dialog,
  DialogContent,
} from "../../../../../shadcnComponents/ui/dialog";
import { ScratchCard } from "./ScratchCard";
// import ScratchCardBg from "./scratch-card.png";
import { CheckCircle, Gift } from "lucide-react";
import { Card, CardContent } from "../../../../../shadcnComponents/ui/card";
import { cn } from "../../../../../lib/utils";
import { Button } from "../../../../../shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
} from "../../../../../shadcnComponents/ui/alert-dialog";
import { useInfluEarningWallet } from "../State/context";

interface FriendCardProps {
  name: string;
  index?: number;
  followers?: number;
  profileImage: string;
  prize?: number;
  onPrizeRevealed?: () => void;
  isClaimed?: boolean;
}

export function FriendCard({
  name,
  index = 0,
  profileImage,
  prize,
  onPrizeRevealed,
  isClaimed = false,
}: FriendCardProps) {
  const [isOpen, setIsOpen] = useState(false);

  const colors = [
    {
      bgColor: "from-[#143592]",
      borderColor: "border-[#143592]",
    },
    {
      bgColor: "from-[#149257]",
      borderColor: "border-[#149257]",
    },
    {
      bgColor: "from-[#921492]",
      borderColor: "border-[#921492]",
    },
    {
      bgColor: "from-[#923E14]",
      borderColor: "border-[#923E14]",
    },
    {
      bgColor: "from-[#921416]",
      borderColor: "border-[#921416]",
    },
  ];
  const { bgColor, borderColor } = colors[index % colors.length];

  const [cardWidth, cardHeight] = [240, 200];

  return (
    <>
      {isOpen && (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogContent
            className="w-auto bg-transparent border-none overflow-hidden p-0 focus:outline-none"
            hideClose
          >
            <div className="flex flex-col items-center">
              {isClaimed ? (
                <div
                  style={{
                    width: `${cardWidth}px`,
                    height: `${prize > 0 ? cardHeight + 30 : cardHeight}px`,
                  }}
                >
                  <div
                    className="w-full h-full flex items-center justify-center rounded-lg"
                    style={{
                      backgroundImage: `url(${
                        prize > 0
                          ? "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/prize-scratch-card-bg.png"
                          : "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/oops-scratch-card-bg.png"
                      })`,
                      backgroundSize: "cover",
                      borderBottom: "5px solid #9633BB",
                    }}
                  >
                    <div className="text-center text-white">
                      {prize > 0 ? (
                        <div className="mt-10">
                          <span className="text-gray-500 text-xs">You won</span>
                          <p className="text-5xl font-bold text-black">
                            ₹{prize}
                          </p>
                        </div>
                      ) : (
                        <p className="text-2xl font-bold text-black">
                          Better luck next time!
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <ScratchCard
                    width={cardWidth}
                    height={cardHeight}
                    image={
                      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Scratch.png"
                    }
                    finishPercent={70}
                    onComplete={() => {
                      onPrizeRevealed?.();
                    }}
                    brushSize={70}
                  >
                    <div className="bg-white bg-gradient-to-r from-purple-500 to-pink-500 w-full h-full flex items-center justify-center rounded-lg">
                      <div className="text-center text-white">
                        {/* <Gift className="w-16 h-16 mx-auto mb-4" /> */}
                        <img
                          src={
                            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/open-gift.png"
                          }
                          alt="gift"
                          className="w-16 h-16 mx-auto"
                        />
                      </div>
                    </div>
                  </ScratchCard>
                  <div className="text-gray-400 text-xs mt-3 text-center">
                    Scratch to claim your reward
                  </div>
                </>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
      <Card
        className={cn(
          "flex-shrink-0 w-full h-full sm:max-w-[210px] sm:min-w-[100px] bg-zinc-900 border-2 bg-gradient-to-t to-transparent bg-clip-border",
          bgColor,
          borderColor
        )}
      >
        <CardContent className="p-2 flex flex-col gap-3 justify-between h-full">
          <div className="space-y-3">
            <img
              src={profileImage}
              alt={name}
              className="rounded-lg max-h-[180px] md:h-[200px] w-full object-cover"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src =
                  "https://collab.anchors.in/FeatredCreatorBackground.png";
              }}
            />
            <div className="text-center">
              <h3 className="text-xs md:text-sm font-semibold line-clamp-1">
                {name}
              </h3>
              {/* {followers > 0 && (
                <p className="text-xs text-[#CEC8C8]">
                  {formatFollowersCount(followers)} Followers
                </p>
              )} */}
            </div>
          </div>
          <Button
            className="w-full text-white border-none transform transition-transform duration-150 text-xs md:text-sm"
            style={{
              background: `linear-gradient(90deg, #E78C25 0.01%, #CF2A9B 30.5%, #B41CEB 65%, #2D33E9 100%)`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = `linear-gradient(90deg, #6A0DAD 0.01%, #8A2BE2 30.5%, #FF69B4 65%, #FF1493 100%)`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = `linear-gradient(90deg, #E78C25 0.01%, #CF2A9B 30.5%, #B41CEB 65%, #2D33E9 100%)`;
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = "scale(0.95)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
            onClick={() => {
              setIsOpen(true);
              mixpanel.track("Scratch & Earn button Clicked", {
                influencerName: name,
              });
            }}
            disabled={isClaimed}
          >
            {isClaimed
              ? `${prize > 0 ? `You won ₹${prize}` : "Better luck next time"}`
              : "Scratch & Earn"}
            {prize !== 0 && <Gift className="size-4 shrink-0 ml-2" />}
          </Button>
        </CardContent>
      </Card>
    </>
  );
}

export function WithdrawModal({ open, onOpenChange, balance }) {
  const { handleWithdrawRequest, loading, success } = useInfluEarningWallet();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[400px] bg-[#212121] text-white border-none">
        <div className="flex flex-col gap-5 items-center justify-center h-full">
          <h1 className=" text-xl font-bold">Withdrawal Request</h1>
          {success?.requestWithdrawal ? (
            <div className="flex flex-col gap-5 items-center justify-center h-full">
              <CheckCircle className="w-16 h-16 text-green-500" />
              <p className="text-sm text-gray-500 text-center">
                Your withdrawal request has been submitted successfully.
              </p>
              <Button variant="destructive" onClick={() => onOpenChange(false)}>
                <span>Got it</span>
              </Button>
            </div>
          ) : (
            <>
              <div className="">
                <p className="text-sm text-gray-500 text-center">Amount</p>
                <p className="text-3xl font-bold">₹{balance}</p>
              </div>
              <p className="text-sm text-gray-500 text-center">
                You are about to request a withdrawal of ₹{balance}. Please
                confirm the request.
              </p>
              <div className="w-full flex justify-center items-center gap-3">
                <AlertDialogCancel asChild>
                  <Button
                    variant="secondary"
                    className="bg-transparent text-white"
                    disabled={loading}
                  >
                    <span>Cancel</span>
                  </Button>
                </AlertDialogCancel>
                <Button
                  variant="destructive"
                  disabled={loading}
                  onClick={handleWithdrawRequest}
                >
                  <span>Confirm</span>
                </Button>
              </div>
            </>
          )}
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
